import { MinusCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Checkbox, Input } from "antd";
import classNames from "classnames";
import { get ,uniqWith,isEqual,clone} from "lodash";
import React, { useEffect, useMemo, useState, useContext } from "react";
import { isMobile } from "../../../utils/common";
import { InputWapper } from "../../../utils/helper";
import "./index.less";
import { contexData } from "@/store";
import { language } from "@/utils/language";

// 普通多选, 存在互斥
export default function BaseCheckbox(props) {
  // console.log("src\\pages\\checkbox\\BaseCheckbox\\index.jsx");
  const { isBack, infoContex } = useContext(contexData); //解构得到属性
  // console.log("isBack : ", isBack);
  const { info = {}, answer = {}, changeAnswer, themeId, isMinimalTheme } = props;
  const minimalTheme =
    Number(themeId || info?.themeId) === 4 || !!isMinimalTheme;
  let scripts = get(info, "scripts") || [];
  let OPTIONCOLUMNS = get(info, "preferences.optionPrefer.optionsColumns", 1);
  if (!OPTIONCOLUMNS) OPTIONCOLUMNS = 1;
  if (info.model == "matrix_checkbox") {
    OPTIONCOLUMNS = get(info, "optionPrefer.optionsColumns", 1) || 1;
  }
  
  // scripts = [`EXCLUSIVE("S20","99","S20","38","")`]
  let exArray = (scripts || [])
    .map((item) => {
      if (item.includes("EXCLUSIVE")) {
        const ex = item
          .replace("EXCLUSIVE", "")
          .replace("(", "[")
          .replace(")", "]");
        // eslint-disable-next-line
        return eval(ex);
      }
      return undefined;
    }).filter((n) => n);
    // exArray= [["Q24b","2","Q24b","1,3",""]]
  const [options] = useState(() => {
    const options = info.options || [];
    let isModuleCollection = false;
    const newOptions = [];
    let index = 0;
    for (let i = 0; i < options.length; i++) {
      if (+options[i].moduleOption === 3) {
        isModuleCollection = true;
        index = i;
        newOptions.push(options[i]);
      } else if (+options[i].moduleOption !== 0) {
        isModuleCollection = false;
      }
      if (isModuleCollection) {
        if (index !== i) {
          const oldChildrenOption =
            newOptions[newOptions.length - 1].childrenOption || [];
          newOptions[newOptions.length - 1].childrenOption = [
            ...oldChildrenOption,
            options[i],
          ];
        }
      } else {
        newOptions.push(options[i]);
      }
    }
    return newOptions;
  });

  exArrayfromtId2(props.info, exArray);

  const [collapseStatus, setCollapseStatus] = useState(() => {
    return (info.options || [])
      .filter((item) => +item.moduleOption === 3)
      .reduce((acc, current) => {
        return {
          ...acc,
          [current.id]: false,
        };
      }, {});
  });

  const [optionSelected, setOptionSelected] = useState(() => {
    // console.log(":::::");
    const selectedArray = isBack
      ? []
      : (info.options || [])
        .filter((item) => +item.selected === 1)
        .map((item) => item.id);
    return selectedArray;
  });
  // console.log("optionSelected::", optionSelected);
  // init radio check
  useEffect(() => {
    const answerObj = answer[info.id];
    if (answerObj) {
      const keys = Object.keys(answerObj);
      if (keys) {
        // console.log("keys::", keys);
        setOptionSelected(keys);
        // console.log("设置默认check");
      }
    }
  }, [answer]);
  useEffect(() => {
    if (optionSelected.length > 0) {
      const newAnswer = {};
      for (let i = 0; i < optionSelected.length; i++) {
        newAnswer[optionSelected[i]] = null;
      }
      changeAnswer(newAnswer);
    }

  
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const width = useMemo(() => {
    // let OPTIONCOLUMNS = get(info, "preferences.optionPrefer.optionsColumns", 1);
    // if (!OPTIONCOLUMNS) OPTIONCOLUMNS = 1;
    let width = 100;
    if (isMobile) {
      if (OPTIONCOLUMNS > 3) {
        OPTIONCOLUMNS = 3;
      }
      width = 99 / OPTIONCOLUMNS;
    }
    width = 99 / OPTIONCOLUMNS;
    return width + "%";
  }, [info]);

  // 点击选项
  const onOptionClick = (option) => () => {
    if (option.fixed || option.disable) return;
    const numIndex = optionSelected.indexOf(option.id);

    // console.log(option, 9999999)
   
    if (numIndex === -1) {
      // 当前选项的互斥id
      const mutualExArr = option.exArrayIdList || [];
      const filterArr = [];
      optionSelected.forEach((item, index) => {
        if (!mutualExArr.includes(item)){
          filterArr.push(item);
        }
      })
      const newSelected = [...filterArr, option.id]
      setOptionSelected([...newSelected])
      let aws ={}
      newSelected.forEach(element => {
        aws[element]=null
        if(answer[info.id]?.[element]){
          aws[element]=answer[info.id][element]
        }
      });

      changeAnswer({
        ...aws,
      });
    } else {
      // 取消选中
      const newOption = [];
      const newAnswer = {};
      for (let i = 0; i < optionSelected.length; i++) {
        if (numIndex !== i) {
          newOption.push(optionSelected[i]);
          newAnswer[optionSelected[i]] = answer[info.id][optionSelected[i]];
        }
      }
      setOptionSelected(newOption);
      changeAnswer(newAnswer);
    }
  };

  const showChechBox = (rowOption) => {
    console.log(rowOption, 2222)
    const mutualExArr = rowOption.exArrayIdList || [];
    const index = optionSelected.findIndex((item) => mutualExArr.includes(item));
    if (index >= 0) {
      return true;
    } else {
      return false;
    }
  }

  // 生成选项
  const getOptions = (options) => {
    if (options && options.length > 0) {
      return (
        <>
          {options.map((option, index) => {
            if (+option.moduleOption === 2 || option.hide) return null;
            if (+option.moduleOption === 1) {
              return (
                <div
                  key={option.id}
                  className="q-content-module"
                  style={{
                    color: infoContex.preferences?.optionColour,
                  }}
                  dangerouslySetInnerHTML={{
                    __html: option.description
                      .replace(/<p><\/p>/g, "<br />")
                      .replace(/\n\n/g, "<br />")
                      .replace(/\s{2}/g, "&nbsp;&nbsp;"),
                  }}
                />
              );
            }
            if (+option.moduleOption === 3) {
              return (
                <React.Fragment key={option.id}>
                  <div
                    className="q-content-module-collapse"
                    onClick={() => {
                      setCollapseStatus((state) => ({
                        ...state,
                        [option.id]: !collapseStatus[option.id],
                      }));
                    }}
                  >
                    {collapseStatus[option.id] ? (
                      <MinusCircleOutlined />
                    ) : (
                      <PlusCircleOutlined />
                    )}
                    <div
                      style={{ color: infoContex.preferences?.optionColour }}
                      dangerouslySetInnerHTML={{
                        __html: option.description
                          .replace(/<p><\/p>/g, "<br />")
                          .replace(/\n\n/g, "<br />")
                          .replace(/\s{2}/g, "&nbsp;&nbsp;"),
                      }}
                    />
                  </div>

                  {collapseStatus[option.id] &&
                    uniqWith(option.childrenOption, isEqual).filter(item=>item.hide!==1).map((childOption) => {

                      // console.log('2222',  uniqWith(option.childrenOption, isEqual) );

                      // ---------------------------------------------------------
                      // 记录上一页答案
                      const answerObj = answer[info.id] || {};
                      const keys = Object.keys(answerObj);
                      let value;
                      keys.map((optId) => {
                        if (optId === childOption.id) {
                          value = answerObj[optId]?.text || answerObj[optId];
                        }
                      });
                      // ---------------------------------------------------------
                      return (
                        <div
                          key={childOption.id}
                          style={{ width, paddingBottom: 10 ,minHeight: 59.64}}
                        >
                          <div
                            className={classNames(
                              "q-content-option",
                              "q-content-childoption"
                            )}
                            onClick={onOptionClick(childOption)}
                           >
                             {showChechBox(childOption) ? (
                              <span style={{ width: 16 }}></span>
                            ): <Checkbox
                            checked={
                              optionSelected.indexOf(childOption.id) > -1
                            }
                            disabled={
                              +childOption.fixed === 1 || childOption.disable
                            }
                          /> }
                            
                            <div
                              style={{
                                marginLeft: 10,
                                color: infoContex.preferences?.optionColour,
                              }}
                              dangerouslySetInnerHTML={{
                                __html: childOption.description,
                              }}
                            />
                              {+childOption.open > 0 &&
                            optionSelected.indexOf(childOption.id) > -1 && (
                              <div style={{ marginLeft: 10 }}   onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                              }}>
                                <InputWapper unit={childOption.unit}>
                                  <Input
                                    placeholder={language().input_placeholder}
                                    value={value}
                                    onChange={(e) =>
                                      changeAnswer({
                                        ...answer[info.id],
                                        [childOption.id]: e.target.value,
                                      })
                                    }
                                  />
                                </InputWapper>
                              </div>
                            )}
                          </div>
                        
                        </div>
                      );
                    })}
                </React.Fragment>
              );
            }
            // ---------------------------------------------------------
            // 记录上一页答案
            const answerObj = answer[info.id] || {};
            const keys = Object.keys(answerObj);
            let value;
            keys.map((optId) => {
              if (optId === option.id) {
                value = answerObj[optId]?.text || answerObj[optId];
              }
            });
            // ---------------------------------------------------------
            return (
              <div key={option.id} style={{ width, paddingBottom: minimalTheme?0:10 ,minHeight: minimalTheme?30:59.64}}>
                <CheckboxWithExclusive
                  info={info}
                  option={option}
                  options={options}
                  exArray={exArray}
                  answer={answer}
                  value={value}
                  onOptionClick={onOptionClick}
                  optionSelected={optionSelected}
                  changeAnswer={changeAnswer}
                  setOptionSelected={setOptionSelected}
                />
              </div>
            );
          })}
        </>
      );
    }

    return null;
  };
  return (
    <div className={classNames("base-checkbox", { "theme-minimal": minimalTheme })}>
      
      <div className={classNames("q-content", { "theme-minimal": minimalTheme })}>
        <div className="q-content-options ">{getOptions(options)}</div>
      </div>
    </div>
  );
}

let inputRef=null

function CheckboxWithExclusive(props) {
  const {
    info,
    answer,
    options,
    option,
    value,
    optionSelected,
    exArray,
    changeAnswer,
    setOptionSelected,
  } = props;
  const { codeValue, id: optionId } = option;
  const [exclusiveList, setExclusiveList] = useState([]);

  const { infoContex } = useContext(contexData); //解构得到属性
   useEffect(() => {
    const list = [];
    exArray.map((ex) => {
      if (ex[0] === info.code) {
        const code = ex[1];
        const others = String(ex[3])
          .split(",")
          .map((n) => +n);
        if (+code === +codeValue) {
          if (+others[0] === 0) {
            list.push(
              options
                .filter((opt) => +opt.codeValue !== +codeValue)
                .map((opt) => opt.codeValue)
            );
          } else {
            list.push(others);
          }
        } else if (+others[0] === 0) {
          list.push(code);
        } else if (others.includes(codeValue)) {
          list.push(code);
        }
      }
      return null;
    });
    // console.log(list,exArray, 1111)
    setExclusiveList(list.flat().map((n) => +n));
    return ()=>{

      console.log('销毁 inputRef=null ');
      inputRef=null
    };
  }, [exArray, codeValue, info.code, options]);

  const code2Id = (code) => options.find((opt) => +opt.codeValue === +code)?.id;

  const hashMap = {};
  options.map((opt) => (hashMap[opt.id] = opt));

  // const propsChange = onOptionClick(option);
  const handleClick = (rowOption) => {
    if(inputRef){
      console.log('inputRef');
      inputRef.blur();
      inputRef=null
    }
    // console.log(option,rowOption, 11111)
    if (option.fixed || option.disable) return;
    const numIndex = optionSelected.indexOf(optionId);
    if (numIndex === -1) {
      // 当前选项的互斥id
      const mutualExArr = option.exArrayIdList || [];
      const filterArr = []
      optionSelected.forEach((item, index) => {
        if (!mutualExArr.includes(item)){
          filterArr.push(item)
        }
      })
      const newSelected = [...filterArr, optionId];
      setOptionSelected([...newSelected])
      const newAnswer = {};
      newSelected.map((id) => {
        newAnswer[id] = answer[info.id]?.[id] || null;
        return undefined;
      });
      changeAnswer({ ...newAnswer });
    } else {
      // 取消选中
      for (let i = 0; i < optionSelected.length; i++) {
        if (optionSelected.includes(optionId)) {
          try {
            delete answer[info.id][optionId];
            if (Object.keys(answer[info.id]).length === 0) {
              delete answer[info.id];
            }
          } catch { }
        }
      }
      const newSelected1 = optionSelected.filter((id) => id !== optionId);
      setOptionSelected(newSelected1);
      changeAnswer(answer[info.id]);
    }
  };


  // 根据互斥条件显示隐藏checkBox
  const showChechBox = (rowOption) => {
    const mutualExArr = rowOption.exArrayIdList || [];
    const index = optionSelected.findIndex((item) => mutualExArr.includes(item));
    if (index >= 0) {
      return true;
    } else {
      return false;
    }
  }
 console.log('optionoption',option);
  return (
    <div
      className="q-content-option"

      onClick={()=>{
        if (showChechBox(option)) return;
        handleClick(option)
      }}
      style={{
        wordBreak: "break-all",
        wordWrap: "breakWord",
        flexWrap:
          +option.open > 0 && optionSelected.indexOf(option.id) > -1
            ? "wrap"
            : "nowrap",
      }}
    >
        { showChechBox(option) ? (
        <span style={{ width: 16 }}></span>
      ) : (
        <Checkbox
          checked={optionSelected.indexOf(optionId) > -1}
          disabled={+option.fixed === 1 || option.disable}
        />
      )}
      <div
        style={{ marginLeft: 10,paddingRight:20, color: infoContex.preferences?.optionColour ,
        width:+option.open>0 ?"":'100%',
      }}
        dangerouslySetInnerHTML={{
          __html: option.description
            .replace(/<p><\/p>/g, "<br />")
            .replace(/\n\n/g, "<br />")
            .replace(/\s{2}/g, "&nbsp;&nbsp;"),
        }}
      /> 
      {+option.open > 0 && optionSelected.indexOf(option.id) > -1 && (
        <div style={{ marginLeft: 10 }}  onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}> 
          <InputWapper unit={option.unit}>
            <Input
             ref={(ee)=>{
               if(ee){
                inputRef=ee
               }
             }}
             placeholder={language().input_placeholder}
              value={value}
             
              onChange={(e) =>
                changeAnswer({
                  ...answer[info.id],
                  [option.id]: e.target.value,
                })
              }
            />
          </InputWapper>
        </div>
      )} 
    </div>
  );
}



const exArrayfromtId2 = (info, _exArra) => {

  try {
// [["Q24b","2","Q24b","1,3",""]]

    let list = info.options;
    let exArra = clone(_exArra);
    let new_exArra=[];
    exArra.map((item,index)=>{
      let newItem=item[1].split(',');
      let newItem2=item[3].split(',');
      newItem.map(item2=>{
        newItem2.map(item3=>{
          new_exArra.push([item[0],item2,item[2], item3,""] )
        });
      })
    })

    let ccclist = list ;
    ccclist.forEach(item => {
      let codeValue = item.codeValue;
      let exArrayIdList = []
      new_exArra.forEach(itemex => {

        if (itemex[1] == codeValue) {
          if (itemex[3] == 0) {
            let idList = list.filter(item3 => item3[1] != item.codeValue).map(ictem => ictem.id)
            exArrayIdList.push(...idList);
          } else {
            exArrayIdList.push(list.find(item3 => item3.codeValue == itemex[3]).id);
          }
        }
        if (itemex[3] == codeValue) {
          exArrayIdList.push(list.find(item3 => item3.codeValue == itemex[1]).id);
        }
        if (itemex[3] == 0) {
          exArrayIdList.push(list.find(item3 => item3.codeValue == itemex[1])?.id);
        }
  
        if (itemex[3]==0 &&itemex[1] == codeValue) {
          
          exArrayIdList=  exArrayIdList.filter(iktem=>iktem!=item.id)
        }
      });
      item.exArrayIdList = exArrayIdList
    });
    
    return ccclist
    
  } catch (error) {
    console.log(error);
     return []
  }
 
}

